export interface CreateCorporateLocationDto {
  name: string; // Required, max 200
  description?: string | null; // Max 1000
  phone?: string | null; // Phone, max 20
  email?: string | null; // Email, max 320
  address?: string | null; // Max 500
  city?: string | null; // Max 100
  state?: string | null; // Max 50
  postalCode?: string | null; // Max 20
  country?: string | null; // Max 100
  timeZone?: string | null; // Max 50
  isPrimary?: boolean; // Default: false
  isActive?: boolean; // Default: true
}
